import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AirportsInfo } from '../../dtos/response/airports-info-response/airports-info';

@Injectable({
  providedIn: 'root',
})
export class AirportsInfoService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = '/airports-info';

  searchAirports(query: string): Observable<AirportsInfo[]> {
    const options = {
      headers: new HttpHeaders({
        background: 'true',
      }),
      params: { query },
    };
    return this.http.get<AirportsInfo[]>(`api/airports-info/search`, options);
  }
}
